import { useState } from 'react'

import { Link, useSearchParams } from 'react-router-dom'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { authService } from 'services/auth.services'

import { routes } from 'utils/routes'

import Button from 'components/form-inputs/button'
import InputField from 'components/form-inputs/input-field'

import { Logo } from 'assets/images'

const ResetPassword = () => {
  const [loading, setLoading] = useState(false)
  const [params] = useSearchParams()

  const validationSchema = Yup.object({
    new_password: Yup.string().label('New password').min(4).required(),
    confirm_password: Yup.string()
      .label('Confirm password')
      .min(4)
      .oneOf([Yup.ref('new_password')], 'Passwords must match')
      .required()
  })

  const formik: any = useFormik({
    initialValues: {
      new_password: '',
      confirm_password: '',
      key: params.get('key'),
      id: params.get('id')
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      authService.updatePassword(values).then(() => {
        setLoading(false)
        formik.resetForm({
          values: {
            new_password: '',
            confirm_password: '',
            key: params.get('key'),
            id: params.get('id')
          }
        })
      })
    }
  })

  return (
    <>
      <section className="flex min-h-screen items-center justify-center bg-gray-100">
        <div className="m-4 flex min-h-[620px] w-full max-w-[58rem] overflow-hidden rounded-3xl bg-white shadow-lg">
          {/* <div
            className="hidden w-[45%] flex-col items-center justify-center bg-cover bg-center bg-no-repeat md:flex"
            style={{ backgroundImage: `url(${LoginBanner})` }}
          ></div> */}

          <div className="flex w-full flex-col justify-between p-6 px-8 py-8 md:w-[55%] lg:px-11">
            <div>
              <div className="mb-4">
                <Link to={routes.dashboard} title="Digital Qcubes" className="block w-fit">
                  <img src={Logo} alt="Logo" className="mb-4 w-20 lg:mb-5 lg:w-24" />
                </Link>
                <h5 className="leading-none font-semibold">Reset Account Password</h5>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <InputField
                  name="new_password"
                  type="password"
                  placeholder="New password"
                  onChange={formik.handleChange}
                  value={formik.values.new_password}
                  onBlur={formik.handleBlur}
                  error={formik.touched.new_password && formik.errors.new_password}
                  required={true}
                />

                <InputField
                  name="confirm_password"
                  type="password"
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  value={formik.values.confirm_password}
                  onBlur={formik.handleBlur}
                  error={formik.touched.confirm_password && formik.errors.confirm_password}
                  required={true}
                />

                <Button
                  label="Reset password"
                  type="submit"
                  className="w-full rounded-md"
                  loading={loading}
                  disabled={!formik.isValid || !formik.dirty}
                />
              </form>
            </div>

            <p className="mt-6 text-center text-sm">
              Already have an account?&nbsp;
              <Link to="/login" className="text-blue-900">
                Login
              </Link>
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
export default ResetPassword
